//
import { API } from "../../api";
async function pay_with_stripe(request) {
    return await new API().apiPost({
        baseUrl: process.env.PAYMENT_ENGINE_URL ?? "",
        endpoint: `v2/stripe/checkout`,
        content: request,
        authorization: process.env.PAYMENT_ENGINE_CLIENT_TOKEN,
    });
}
export { pay_with_stripe };
